// Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved.

export class RecaptchaSettings {
    get isEnabled(): boolean {
        return window.recaptchaEnabled;
    }

    get apiKey(): string {
        return window.recaptchaKey;
    }
}

export default new RecaptchaSettings();
